import { render, staticRenderFns } from "./DataProtection.vue?vue&type=template&id=5658ea55&"
import script from "./DataProtection.js?vue&type=script&lang=js&"
export * from "./DataProtection.js?vue&type=script&lang=js&"
import style0 from "./DataProtection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports